<template>
  <div class="wrapper" :class="{ hidingSideBar, minimized }">
    <side-bar class="side-bar" v-model="minimized">
      <mobile-menu slot="content"></mobile-menu>

      <sidebar-link v-for="link in availableLinks" :key="link.to" :to="link.to">
        <span
          class="icon-wrapper d-flex justify-content-center align-items-center"
        >
          <svg
            v-if="link.str === 'Klantoverzicht'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Winkel'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Marketing'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 600 600"
          >
            <g
              transform="matrix(42.857142857142854,0,0,42.857142857142854,0,0)"
            >
              <g>
                <path
                  d="M12.84,12.07,1.17,8A1,1,0,0,1,.5,7.09V6a1,1,0,0,1,.67-.94L12.84,1a.5.5,0,0,1,.66.47V11.6A.5.5,0,0,1,12.84,12.07Z"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M8.48,10.57A2.75,2.75,0,0,1,3,10.25V8.66"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Gebruikersaccounts'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Categorieën'"
            width="14"
            height="14"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  d="M13.28,9.39,9.39,13.28a.75.75,0,0,1-1.06,0L.61,5.56A.36.36,0,0,1,.5,5.27l.59-3.83a.37.37,0,0,1,.35-.35L5.27.5a.36.36,0,0,1,.29.11l7.72,7.72A.75.75,0,0,1,13.28,9.39Z"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <circle
                  cx="4.11"
                  cy="4.11"
                  r="0.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></circle>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Alle producten'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  stroke-width="1"
                  d="M1.5,8.5V13a.5.5,0,0,0,.5.5H12a.5.5,0,0,0,.5-.5V8.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <line
                  stroke-width="1"
                  x1="8"
                  y1="8.5"
                  x2="8"
                  y2="13.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
                <line
                  stroke-width="1"
                  x1="1.5"
                  y1="10"
                  x2="8"
                  y2="10"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
                <polygon
                  stroke-width="1"
                  points="0.5 4 2 0.5 12 0.5 13.5 4 0.5 4"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></polygon>
                <path
                  stroke-width="1"
                  d="M4.75,4V5a2,2,0,0,1-2,2H2.47a2,2,0,0,1-2-2V4"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <path
                  stroke-width="1"
                  d="M9.25,4V5a2,2,0,0,1-2,2h-.5a2,2,0,0,1-2-2V4"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <path
                  stroke-width="1"
                  d="M13.5,4V5a2,2,0,0,1-2,2h-.25a2,2,0,0,1-2-2V4"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Kortingen'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Merken'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  d="M13.25,9.36,9.36,13.25a.75.75,0,0,1-1.06,0L1.79,6.74a.36.36,0,0,1-.11-.29l.59-3.84a.37.37,0,0,1,.34-.34l3.84-.59a.36.36,0,0,1,.29.11L13.25,8.3A.75.75,0,0,1,13.25,9.36Z"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <line
                  x1="4.03"
                  y1="4.03"
                  x2="0.53"
                  y2="0.53"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Orderpicken'"
            width="14"
            height="14"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 14"
          >
            <g>
              <line
                x1="7"
                y1="0.5"
                x2="7"
                y2="4.5"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></line>
              <line
                x1="8.5"
                y1="11"
                x2="11"
                y2="11"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></line>
              <path
                d="M.5,4.5h13a0,0,0,0,1,0,0v8a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1v-8A0,0,0,0,1,.5,4.5Z"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M.5,4.5,2,1.61A2,2,0,0,1,3.74.5h6.52a2,2,0,0,1,1.79,1.11L13.5,4.5"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Leveranciers'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  d="M.5,4.5h13a0,0,0,0,1,0,0V13a.5.5,0,0,1-.5.5H1A.5.5,0,0,1,.5,13V4.5A0,0,0,0,1,.5,4.5Z"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <path
                  d="M.5,4.5h0a4,4,0,0,1,4-4h5a4,4,0,0,1,4,4h0"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <path
                  d="M11,13.5V8a.5.5,0,0,0-.5-.5h-7A.5.5,0,0,0,3,8v5.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <line
                  x1="3"
                  y1="9.5"
                  x2="11"
                  y2="9.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
                <line
                  x1="3"
                  y1="11.5"
                  x2="11"
                  y2="11.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Productgroep'"
            class="group"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Website Producten'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Overzicht bestellingen'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Advies bestelling'"
            width="14"
            height="14"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  d="M4.5,12.5l-4,1,1-3v-9a1,1,0,0,1,1-1h10a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1Z"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <line
                  x1="7.5"
                  y1="3"
                  x2="7.5"
                  y2="6"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
                <circle
                  cx="7.5"
                  cy="9"
                  r="0.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></circle>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Aanvulling'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <rect
                  x="0.5"
                  y="0.5"
                  width="13"
                  height="13"
                  rx="3"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></rect>
                <polyline
                  points="4 7 7 10.5 10 7"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></polyline>
                <line
                  x1="7"
                  y1="10.5"
                  x2="7"
                  y2="3.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
              </g>
            </g>
          </svg>
        </span>

        <transition @enter="enter" @leave="leave">
          <p v-if="!minimized">{{ link.str }}</p>
        </transition>
      </sidebar-link>
    </side-bar>
    <div class="main-panel d-flex flex-column">
      <div style="height: 50px"></div>

      <dashboard-content @click="toggleSidebar" />
    </div>

    <top-navbar v-model="hidingSideBar"></top-navbar>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";

import { mapState } from "vuex";

import { getAvailableSitesByRole, links } from "src/utils/userRoleSite.js";
import transitionFunctionConstructor from "../mixins/transitionFunctionConstructor";

export default {
  mixins: [transitionFunctionConstructor("enter", "leave", "width")],
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      hidingSideBar: false,
      sidebarLinks: links,
      minimized: false,
    };
  },
  created() {
    this.$checkAuthentication();
    this.cacheMainEndpoints();

    const minimized = JSON.parse(
      localStorage.getItem("is_sidebar_minimized") || "false"
    );
    if (minimized) this.minimized = minimized;
  },
  methods: {
    async cacheMainEndpoints() {
      try {
        await this.axios.get(`/drop/products`);
      } catch (err) {
        await this.axios.post(`/drop/login`, {
          email: "contact@aegal.nl",
          password: "#4tfu5!hM^d4^T%",
        });
      }

      const endpoints = [
        {
          endpoint: "/api/products",
          params: {
            params: { page_size: 50, page: 1, sort: "name", sort_type: "asc" },
          },
        },
        {
          endpoint: "/api/websites",
          params: { params: { page_size: 30, page: 1 } },
        },
        {
          endpoint: "/api/customers",
          params: { params: { page_size: 15, page: 1 } },
        },
        {
          endpoint: "/api/discounts",
          params: { params: { page_size: 15, page: 1 } },
        },
        {
          endpoint: "/api/accounts",
          params: { params: { page_size: 15, page: 1 } },
        },
        {
          endpoint: "/api/brands",
          params: { params: { page_size: 15, page: 1 } },
        },
        {
          endpoint: "/api/suppliers",
          params: { params: { page_size: 15, page: 1 } },
        },
        {
          endpoint: "/api/categories",
          params: { params: { page_size: 15, page: 1, format: "tree" } },
        },
        {
          endpoint: "/api/orders",
          params: { params: { state: "SENT_TO_POSTNL" } },
        },

        {
          endpoint: "/drop/products",
          params: { params: { page_size: 30, page: 1 } },
        },
        { endpoint: "/drop/products/order" },
        { endpoint: "/drop/products/settings" },
        { endpoint: "/drop/settings" },
      ];

      endpoints.forEach((param) =>
        this.$store.dispatch("keepTrackOfEndpoint", param)
      );
    },

    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  computed: {
    ...mapState({
      userRole: (state) => state.user && state.user.role,
    }),

    availableLinks() {
      const links = this.roleLinks || [];

      return links.length
        ? this.sidebarLinks.filter((item) => links.includes(item.to))
        : this.sidebarLinks;
    },
    roleLinks() {
      return getAvailableSitesByRole(this.userRole);
    },
  },
  watch: {
    minimized(val) {
      localStorage.setItem("is_sidebar_minimized", val ? "true" : "");
    },
  },
};
</script>

<style>
html {
  overflow: auto;
}
</style>

<style scoped>
.icon-wrapper {
  width: 40px;
}

.group {
  transform: translate(2.5px, 2.5px);
}

@media (min-width: 993px) {
  .side-bar {
    transition-duration: 0.2s !important;
    transform: translateX(0px) !important;
    transition-property: all;
  }

  .hidingSideBar .side-bar {
    transform: translateX(-100%) !important;
  }

  .main-panel {
    width: calc(100% - 200px);
    transition-property: all;
    transition-duration: 0.2s;
  }

  .hidingSideBar .main-panel {
    width: 100% !important;
  }
}

a {
  color: white;
}

img {
  margin-right: 13px;
}

.nc-icon {
  margin-top: -8px;
}

.minimized .main-panel {
  width: calc(100% - 60px) !important;
}
</style>
